import { render, staticRenderFns } from "./CatalogWorkflow.vue?vue&type=template&id=7514956a"
import script from "./CatalogWorkflow.vue?vue&type=script&lang=js"
export * from "./CatalogWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports